import React from 'react';
import styled from 'styled-components/macro';
import Box from 'Application/components/Static/Box';
import { ErrorRounded } from '@material-ui/icons';
import { useHistory } from 'react-router';
import { Helmet } from 'react-helmet-async';
import Button from 'Common/components/Button';

const StyledBox = styled(Box)`
    padding-top: 50px;
    padding-bottom: 50px;
    text-align: center;

    svg {
        font-size: 70px;
    }
`;

const PageNotFound = () => {
    const history = useHistory();

    const handleBackButtonClick = () => {
        history.goBack();
    };

    return (
        <StyledBox>
            <Helmet>
                <title>Page not found</title>
            </Helmet>
            <ErrorRounded />
            <h1>Error 404</h1>
            <h2>Seite nicht gefunden</h2>
            <Button type="button" onClick={handleBackButtonClick}>
                Zurück
            </Button>
        </StyledBox>
    );
};

export default PageNotFound;
